import { Time } from '../types'
import { hoursFromSeconds, minutesFromSeconds } from '@utils/time'
import { nullTime } from './nullTime'

export const convertSecondsFromMidnightIntoTime = (
  seconds: number | null,
): Time => {
  if (seconds === null) return nullTime

  return {
    hour: hoursFromSeconds(seconds),
    minute: minutesFromSeconds(seconds),
  }
}
